var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "related-designs-wrap" },
    [
      _c(
        "l-accordion",
        { attrs: { isOpen: true, title: _vm.t(this.actualTitle) } },
        [
          _vm.relatedDesigns.length > 0
            ? _c("products-swiper", {
                attrs: { products: _vm.relatedDesignsSkus() },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }